module.exports = __webpack_public_path__ + "static/gallery-img-30-0ad37e8bebfbe01fe2f54932d1fc4a82.jpg";